<template>
  <div class="mall-page">
    <div class="mall-container">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="书籍订购" name="mall">
          <line-mall-list></line-mall-list>
        </el-tab-pane>
        <el-tab-pane label="我的订单" name="order">
          <line-mall-order-list></line-mall-order-list>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import lineMallList from "./components/lineMallList.vue";
import lineMallOrderList from "./components/lineMallOrderList.vue";
export default {
  data() {
    return { activeTab: "mall" };
  },
  components: { lineMallList, lineMallOrderList },
  methods: {
    reload() { this.activeTab = "order"; },
  },
};
</script>

<style scoped>
.mall-page { max-width: 1000px; margin: 30px auto; }
.mall-container { background: #fff; border-radius: 6px; padding: 24px; }
.mall-container >>> .el-tabs__item.is-active { color: #f56c6c; }
.mall-container >>> .el-tabs__item:hover { color: #f56c6c; }
</style>
